import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    saved: localStorage.getItem("SAVED") && JSON.parse(localStorage.getItem("SAVED")),
    img: null,
    req: null
  },
  mutations: {
    changeImage (state,payload) {
      // 变更状态
      state.img = payload
    },
    updateInfo (state,payload) {
      // 变更状态
      state.req = payload
    },
    save (state,payload) {
      console.log(payload)
      const saved = {
        union : payload.union,
        username : payload.username,
        company : payload.company,
        zipcode : payload.zipcode,
        address : payload.address,
        telno : payload.telno,
        price: payload.price,
      }
      state.saved = saved

      localStorage.setItem("SAVED",JSON.stringify(state.saved))
    },
    clear (state){
      state.req = null
    },
  },
  actions: {
  },
  modules: {
  },
});
